//import ModeloRestaurante from '../../models/Restaurante'
import { Prato } from '../../pages/Categories'
//import { Restaurant } from '../../pages/Home'
import PratosRestaurante from '../PratosRestaurante'
import pratoimagem from '../../assets/images/prato.png'

import { Container, List } from './styles'

export type Props = {
  pratos: Prato[]
}

const prato = {
  id: 1,
  foto: pratoimagem,
  nome: 'Hioki Sushi',
  descricao:
    'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Vero, nihil suscipit nam libero, ipsum sit saepe inventore veritatis quis hic, assumenda molestias reprehenderit officiis natus earum cupiditate perspiciatis excepturi. Mollitia?',
  porcao: 'serve 2 pessoas',
  preco: 89.9
}

const ListaPratos = () => (
  <Container className="container">
    <div>
      <List>
        <PratosRestaurante
          id={prato.id}
          foto={prato.foto}
          nome={prato.nome}
          descricao={prato.descricao}
          porcao={prato.porcao}
          preco={prato.preco}
        />
      </List>
    </div>
  </Container>
)

export default ListaPratos
